import { locale } from '@tcc/i18n';
import { ApplicationProduct } from '../types/Application';
import { SortField, SortDirection } from '../types/Sort';

interface NaturalSortCompareParams {
  aValue: string;
  bValue: string;
  sortDirection: SortDirection;
}

export const productNameNaturalSortCompare = ({ aValue, bValue, sortDirection }: NaturalSortCompareParams) => {
  const result = aValue.localeCompare(bValue, locale, {
    numeric: true,
    sensitivity: 'base'
  });

  return sortDirection === SortDirection.ASC ? result : -result;
};

export function sortApplicationProducts(
  products: ApplicationProduct[], 
  sortField: SortField, 
  sortDirection: SortDirection,
): ApplicationProduct[] {
  return [...products].sort((a, b) => {
    let aValue: string | number;
    let bValue: string | number;
    
    switch (sortField) {
      case SortField.NAME:
        return productNameNaturalSortCompare({
          aValue: a.name,
          bValue: b.name,
          sortDirection,
        });
      case SortField.RATE:
        aValue = a.rate.q;
        bValue = b.rate.q;
        break;
      case SortField.APPLIED:
        aValue = a.applied.q;
        bValue = b.applied.q;
        break;
      default:
        return 0;
    }
    
    if (aValue < bValue) return sortDirection === SortDirection.ASC ? -1 : 1;
    if (aValue > bValue) return sortDirection === SortDirection.ASC ? 1 : -1;
    return 0;
  });
}